// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loading-dots_loadingWrapper__RX7IZ","loadingDots":"loading-dots_loadingDots__pZKnK"};